__webpack_require__.p = "/scavenger/shroom22/";